import React from 'react';
import { Drawer, Radio } from 'antd';

interface OptionSheetProps {
  open: boolean;
  title: string;
  value?: string;
  options: { value: string; label: React.ReactNode }[];
  onChange: (value: string) => void;
  onClose: () => void;
}

const OptionSheet: React.FC<OptionSheetProps> = ({ open, title, value, options, onChange, onClose }) => (
  <Drawer
    placement="bottom"
    open={open}
    onClose={onClose}
    title={title}
    size="auto"
    styles={{ wrapper: { maxHeight: '85vh', borderRadius: '16px 16px 0 0', overflow: 'hidden' } }}
  >
    <Radio.Group
      value={value}
      onChange={(e) => onChange(String(e.target.value))}
      style={{ display: 'flex', flexDirection: 'column', paddingBottom: 'env(safe-area-inset-bottom)' }}
      data-testid="mobile-option-sheet"
    >
      {options.map((option) => (
        <Radio key={option.value} value={option.value} style={{ minHeight: 44, alignItems: 'center' }}>
          {option.label}
        </Radio>
      ))}
    </Radio.Group>
  </Drawer>
);

export default OptionSheet;
